<div class="main-header" *ngIf="virtual_reception.config_module === 'inspraai_cc'">
    <h2>INSPRA Contact Center Service - [ {{ virtual_reception.service_reference }} ]</h2>
</div>

<div class="main-header" *ngIf="virtual_reception.config_module === 'inspraai_ib'">
    <h2>INSPRA Inbound Service </h2>
</div>
<!-- message notif -->
<div class="_notification" *ngIf="error_message == 'Service does not exist' || error_message">
    <div class="col">
      <div class="alert alert-danger" role="alert">
        <span class="state-icon"><i class="fas fa-check"></i></span>
        <p>{{ error_message }}</p>
      </div>
    </div>
  </div>
  <div class="_notification" *ngIf="submit_success">
    <div class="col">
      <div class="alert alert-success" role="alert">
        <span class="state-icon"><i class="fas fa-check"></i></span>
        <p>{{ submit_success }}</p>
      </div>
    </div>
  </div>
  
  <div class="_notification-dialog-wrapper" *ngIf="show_reset_change_notification">
    <div class="_notification-dialog">
      <div class="notif-container">
        <header>{{ show_reset_change_notification }}</header>
        <div class="notif-content">
          <p>Some changes you made have not yet been saved. Leave anyway?</p>
        </div>
        <div class="notif-action row">
          <div class="col-md-6 text-left">
            <button class="btn btn-default modal-confirm" (click)="closeResetModal('true')">
              Continue
            </button>
          </div>
          <div class="col-md-6 text-right">
            <button class="btn btn-primary modal-dismiss" (click)="closeResetModal('false')">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
<main>
    <div
    class="modal-content-slide"
    [className]="
      show_slider
        ? 'modal-content-slide fader _open'
        : 'modal-content-slide fader'
    "
  >
    <div class="modal-control-close">
      <span (click)="goBack()">Back</span>
    </div>
  
    <div class="modal-content-wrap">

        <div
        class="serv-block"
        *ngIf="show_signoff_configuration"
        >
        <!-- <header class="serv-block-name">Connection List</header> -->

        <div class="serv-group margin-top-10">
            <form>

                <div class="card border-0 shadow-sm mt-4">
                  <div class="card-header bg-white">
                    <h4 class="mb-0  fw-bold" style="font-weight: 700;">Sign-off Message</h4>
                    <small class="text-muted">
                        Write a custom sign-off that your AI Bot will use when closing calls to your business.
                    </small>
                  </div>
              
                  <div class="card-body">
              
                    <!-- inspraai_cc -->
                    <div >
              
                      <div class="form-group">
                        <label class="font-weight-bold">Sign-off Message</label>
                        <input
                          name="connectionEmail"
                          [(ngModel)]="virtual_reception.sign_off"
                          class="form-control"
                          type="email"
                          placeholder="e.g. support@company.com"
                        />
                      </div>
              
                      
              
                    </div>
              
                    <!-- inspraai_ib -->
                   
              
                  </div>
              
                  <div class="card-footer bg-white text-right">
                    <button
                      type="button"
                      class="btn btn-primary px-4"
                      (click)="vrSaveConfiguration()">
                      Save Configuration
                    </button>
                  </div>
              
                </div>
              
              </form>
        </div>
        </div>


        <div
        class="serv-block"
        *ngIf="show_email_subject_configuration"
        >
        <!-- <header class="serv-block-name">Connection List</header> -->

        <div class="serv-group margin-top-10">
            <form>

                <div class="card border-0 shadow-sm mt-4">
                  <div class="card-header bg-white">
                    <h4 class="mb-0  fw-bold" style="font-weight: 700;">Email Subject</h4>
                    <small class="text-muted">
                        Write a custom Email Subject that your AI Bot will use.
                    </small>
                  </div>
              
                  <div class="card-body">
              
                    <!-- inspraai_cc -->
                    <div >
              
                      <div class="form-group">
                        <label class="font-weight-bold">Email Subject</label>
                        <input
                          name="emailSubject"
                          [(ngModel)]="virtual_reception.email_subject"
                          class="form-control"
                          type="text"
                          placeholder="Write you email subject"
                        />
                      </div>
              
                    </div>
                  </div>
              
                  <div class="card-footer bg-white text-right">
                    <button
                      type="button"
                      class="btn btn-primary px-4"
                      (click)="vrSaveConfiguration()">
                      Save Configuration
                    </button>
                  </div>
              
                </div>
              
              </form>
        </div>
        </div>

        <div
        class="serv-block"
        *ngIf="show_primary_recipient_configuration"
        >
        <!-- <header class="serv-block-name">Connection List</header> -->

        <div class="serv-group margin-top-30">
            <form>

                <div class="card border-0 shadow-sm mt-4">
                  <div class="card-header bg-white">
                    <h4 class="mb-0  fw-bold" style="font-weight: 700;">Connection List</h4>
                    <small class="text-muted">
                      Configure where your AI Bot will send messages or notifications.
                    </small>
                  </div>
              
                  <div class="card-body">
              
                    <!-- inspraai_cc -->
                    <div *ngIf="virtual_reception.config_module === 'inspraai_cc'">
              
                      <div class="form-group">
                        <label class="font-weight-bold">Email Recipient</label>
                        <input
                          name="connectionEmail"
                          [(ngModel)]="virtual_reception.connection_list[0]"
                          class="form-control"
                          type="email"
                          placeholder="e.g. support@company.com"
                        />
                      </div>
              
                      <div class="form-group mt-4">
                        <label class="font-weight-bold">Contact Number</label>
                        <input
                          name="connectionPhone"
                          [(ngModel)]="virtual_reception.connection_list[1]"
                          class="form-control"
                          type="text"
                          placeholder="e.g. +61412345678"
                        />
                      </div>
              
                    </div>
              
                   <!-- inspraai_ib -->
                    <div *ngIf="virtual_reception.config_module === 'inspraai_ib'">

                        <div class="alert alert-info mb-4">
                        <strong>Note:</strong> Select where your AI Bot should send messages.
                        </div>
                    
                        <div class="form-group">
                        <label class="font-weight-bold">Send To</label>
                        <select
                        class="form-control"
                        name="connectionDestinationType"
                        [(ngModel)]="connection_destination_type"
                        (ngModelChange)="virtual_reception.connection_list[0] = ''">

                        <option value="">-- Select Connection Type --</option>
                        <option value="email">Email</option>
                        <option value="mobile">Contact Number</option>
                        </select>
                        </div>
                    
                        <!-- Email -->
                        <div
                        class="form-group mt-4"
                        *ngIf="connection_destination_type === 'email'">
                    
                        <label class="font-weight-bold">Email Address</label>
                    
                        <input
                            class="form-control"
                            type="email"
                            name="connectionEmail"
                            [(ngModel)]="virtual_reception.connection_list[0]"
                            placeholder="support@company.com">
                        </div>
                    
                        <!-- Mobile -->
                        <div
                        class="form-group mt-4"
                        *ngIf="connection_destination_type === 'mobile'">
                    
                        <label class="font-weight-bold">Mobile Number</label>
                    
                        <input
                            class="form-control"
                            type="text"
                            name="connectionMobile"
                            [(ngModel)]="virtual_reception.connection_list[0]"
                            placeholder="+61412345678">
                        </div>
                    
                    </div>
              
                  </div>
              
                  <div class="card-footer bg-white text-right">
                    <button
                      type="button"
                      class="btn btn-primary px-4"
                      (click)="vrSaveConfiguration()">
                      Save Configuration
                    </button>
                  </div>
              
                </div>
              
              </form>
        </div>
        </div>
    
      <!-- Greeting -->
      <div
        class="serv-block"
        *ngIf="
          show_personalize_greetings_configuration &&
          error_message != 'Service does not exist'
        "
      >
        <!-- <header class="serv-block-name">Greeting</header> -->
  
        <div class="serv-group margin-top-30">
          <form>
  
            <!-- Greeting Type -->
            <div class="row serv-miniblock" *ngIf="ocms_plan">
              <div
                class="col-lg-8 col-md-12"
                *ngIf="
                  !virtual_reception.personalised_greeting ||
                  virtual_reception.personalised_greeting == '0'
                "
              >
                <p class="--notes">
                  <strong>Standard greeting</strong>
                  <span>Free</span>
                  <span>
                    Operators will use the standard greeting when answering calls
                    for your business.
                  </span>
                </p>
              </div>
  
              <div
                class="col-lg-8 col-md-12"
                *ngIf="virtual_reception.personalised_greeting == '1'"
              >
               
              </div>
  
              <div class="form-group col-lg-4 col-md-12">
                <div
                  [className]="
                    virtual_reception.personalised_greeting == '1'
                      ? 'add-label-standard'
                      : 'add-label-personal'
                  "
                >
                  <div class="serv-select-field valign-middle">
                    <!-- <label
                      class="select-label {{
                        virtual_reception.personalised_greeting == '1'
                          ? 'text-blue'
                          : 'text-red'
                      }}"
                    >
                      {{
                        virtual_reception.personalised_greeting == '0'
                          ? 'Free'
                          : 'Add-on'
                      }}
                    </label> -->
  
                    <select
                      name="personalised_greeting"
                      [(ngModel)]="virtual_reception.personalised_greeting"
                      [disabled]="
                        !internal_config
                          .getPermission()
                          .includes('myalltel/config')
                      "
                      (ngModelChange)="selectGreetingType()"
                    >
                      <option [value]="0">Standard Greeting</option>
                      <option [value]="1">Personalised Greeting</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
  
            <!-- Standard Greeting -->
            <div
              class="row serv-sub-miniblock"
              *ngIf="
                ocms_plan &&
                virtual_reception.personalised_greeting == '0'
              "
            >
              <div class="form-group col-md-12">
                <label>Greeting business name</label>
  
                <div class="flux-field-group">
                  <input
                    type="text"
                    name="greeting_business_name"
                    [(ngModel)]="virtual_reception.greeting_business_name"
                    maxlength="55"
                    [disabled]="
                      !internal_config
                        .getPermission()
                        .includes('myalltel/config')
                    "
                  />
                </div>
  
                <span class="text-counter">
                  {{
                    characterLength(
                      virtual_reception.greeting_message
                    )
                  }}/55 character max
                </span>
              </div>
            </div>
  
            <!-- Personalised Greeting -->
            <div
  class="card border-0 shadow-sm mt-4"
  *ngIf="
    !ocms_plan ||
    virtual_reception.personalised_greeting == '1'
  "
>
  <div class="card-header bg-white">
    <h4 class="mb-1  fw-bold" style="font-weight: 700;">Greeting Configuration</h4>
    <small class="text-muted">
      Customize how your AI Bot introduces itself when answering calls.
    </small>
  </div>

  <div class="card-body">

    <!-- Call Centre -->
    <div *ngIf="virtual_reception.config_module === 'inspraai_cc'">

      <label class="font-weight-bold">Greeting Message</label>

      <input
        class="form-control"
        name="greeting_message"
        [(ngModel)]="virtual_reception.greeting_message"
        maxlength="120"
        placeholder="e.g. Welcome to [business_name], you're speaking with [AGENT_NAME]. How can I help?"
      />

      <div class="d-flex justify-content-between mt-2">
        

        <small class="text-muted">
          {{ characterLength(virtual_reception.greeting_message) }}/120
        </small>
      </div>

    </div>

    <!-- Inbound -->
    <div *ngIf="virtual_reception.config_module === 'inspraai_ib'">

      <label class="font-weight-bold">Business Name</label>

      <input
        class="form-control"
        name="business_name"
        [(ngModel)]="virtual_reception.business_name"
        (ngModelChange)="onBusinessNameChange($event)"
        maxlength="120"
        placeholder="Enter your business name"
      />

      <div class="d-flex justify-content-between mt-2">
        <small class="text-muted">
          This name will be used by your AI Bot when answering calls.
        </small>

        <small class="text-muted">
          {{ characterLength(virtual_reception.business_name) }}/120
        </small>
      </div>

    </div>

  </div>

  <div class="card-footer bg-white text-right">
    <button
      type="button"
      class="btn btn-primary px-4"
      (click)="vrSaveConfiguration()"
      [disabled]="
        !internal_config
          .getPermission()
          .includes('myalltel/config')
      "
    >
      Save Greeting
    </button>
  </div>
</div>
  
          </form>
        </div>
      </div>
  
    </div>
  </div>
  <div class="modal-backdrop" *ngIf="showConnectionListModal">
    <div class="modal">
      <h3>Connection !!!!!!!!!!List</h3>
  
      <!-- Your modal content here -->
  
      <button (click)="showConnectionListModal = false">
        Close
      </button>
    </div>
  </div>
<div class="main-wrapper">
    <!-- services detail -->
    <div class="row">
      <div class="col">
        <section class="card myalltel-section mt-3">
          <header [className]="
              show_service_detail_configuration == true
                ? 'card-header header-title  __active'
                : 'card-header header-title  __inactive'
            ">
            <h2 class="card-title col-md-6">Service detail</h2>
            <!-- <img src="../assets/images/arrow-chevron.svg" class="header-arrow" alt="up" (click)="showServiceDetailConfiguration()" /> -->
          </header>
          <div class="card-body myalltel-form-detail">
            <form>
              <div class="form-group row detail-row fullwidth-border">
                <div class="form-group col-lg-4 col-md-6 separator">
                  <label for="staticEmail" class="col-form-label">Service reference number</label>
                  <input type="text" readonly class="form-control-plaintext" name="service_reference"
                    [(ngModel)]="virtual_reception.service_reference" />
                  <span>({{ virtual_reception.indial_number }})</span><br />
                  This is the number to forward your phones to so operators can
                  take your calls.
                </div>
                <div class="form-group col-lg-4 col-md-6 separator">
                  <label for="staticEmail" class="col-form-label">Plan</label>
                  <input type="text" readonly class="form-control-plaintext" name="plan"
                    [(ngModel)]="virtual_reception.plan" />
                </div>
                <div class="form-group col-lg-4 col-md-6">
                  <label for="staticEmail" class="col-form-label">Service status</label>
                  <input type="text" readonly class="form-control-plaintext" name="service_status"
                    [(ngModel)]="virtual_reception.service_status" />
                </div>

                <div class="form-group col-lg-4 col-md-6 separator">
                  <label for="staticEmail" class="col-form-label">Category name</label>
                  <input type="text" readonly class="form-control-plaintext" name="category_name"
                    [(ngModel)]="virtual_reception.category_name" />
                </div>
                <div class="form-group col-lg-4 col-md-6 separator">
                  <label for="staticEmail" class="col-form-label">Created</label>
                  <input type="text" readonly class="form-control-plaintext" name="created"
                    [(ngModel)]="virtual_reception.created" />
                </div>
                <div class="form-group col-lg-4 col-md-6">
                  <label for="staticEmail" class="col-form-label">Disconnected</label>
                  <input type="text" readonly class="form-control-plaintext" name="cancellation_date"
                    [(ngModel)]="virtual_reception.cancellation_date" />
                </div>
              </div>
            </form>
          </div>
        </section>
      </div>
    </div>
    <!-- /services  -->

    <!-- service controller -->
    <div class="row service-controllers">
      <!-- recipient -->
      <div class="serv-control-box col-lg-4 col-md-12" *ngIf="error_message != 'Service does not exist'"
        (click)="showSlider()" (click)="showPrimaryRecipientConfiguration()">
        <section>
          <header [className]="
              show_primary_recipient_configuration == true
                ? 'card-header header-title  __active'
                : 'card-header header-title  __inactive'
            ">
            <h2 class="card-title col-md-6">Connection List</h2>
            <img src="../assets/images/arrow-chevron.svg" class="float-right" alt="up" />
            <p>
              Tell us who to send your messages to by entering the relevant
              email address and phone number.
            </p>
          </header>
        </section>
      </div>

      <!-- department -->
    

      <!-- greetings  -->
      <div class="serv-control-box col-lg-4 col-md-12" *ngIf="error_message != 'Service does not exist'"
        (click)="showSlider()" (click)="showPersonalizeGreetingsConfiguration()">
        <section>
          <header [className]="
              show_personalize_greetings_configuration == true
                ? 'card-header header-title  __active'
                : 'card-header header-title  __inactive'
            ">
            <h2 class="card-title col-md-6">Greeting</h2>
            <img src="../assets/images/arrow-chevron.svg" class="float-right" alt="up" />
                <p *ngIf="virtual_reception.config_module === 'inspraai_cc'">
                Write a custom greeting that your AI Bot will use when answering
                calls for your business .
              </p>
              
              <p *ngIf="virtual_reception.config_module === 'inspraai_ib'">
                Configure the business name that your AI Bot will use when answering
                calls for your business.
              </p>
          </header>
        </section>
      </div>

      <!-- sign off -->
      <div class="serv-control-box col-lg-4 col-md-12" *ngIf="error_message != 'Service does not exist' &&
      virtual_reception.config_module === 'inspraai_cc'" 
        (click)="showSlider()" (click)="showSignOffConfiguration()">
        <section>
          <header [className]="
              show_signoff_configuration == true
                ? 'card-header header-title  __active'
                : 'card-header header-title  __inactive'
            ">
            <h2 class="card-title col-md-6">Sign-off</h2>
            <img src="../assets/images/Up.svg" class="float-right" alt="up" />
            <p>
              Write a custom sign-off that your AI Bot will use when closing calls
              to your business or use our default sign-off.
            </p>
          </header>
        </section>
      </div>

      <!-- question -->
      <div class="serv-control-box col-lg-4 col-md-12" *ngIf="error_message != 'Service does not exist'"
        (click)="showSlider()" (click)="showEmailSubjectConfiguration()">
        <section>
          <header [className]="
          show_email_subject_configuration == true
                ? 'card-header header-title  __active'
                : 'card-header header-title  __inactive'
            ">
            <h2 class="card-title col-md-6">Email Subject</h2>
            <img src="../assets/images/Up.svg" class="float-right" alt="up" />
            <p>Configure your email subject.</p>
          </header>
        </section>
      </div>

      <!-- config -->
     
    </div>
  </div>
  
</main>
